import { useCallback } from 'react';
import { API_ENDPOINTS } from '../config/api/apiCall';
import { RequestIndentCRUD } from '../services/requestIndentService';

const useSalaryStructureCRUD = (callMessage) => {

    const processIndent = useCallback(async (selectedMode, editSalaryStructureID, requestBody) => {
        try {
            const apiEndpoint = selectedMode === 0
                ? API_ENDPOINTS.SALARY_STRUCTURE_COMPONENTS_CRUD
                : API_ENDPOINTS.SALARY_STRUCTURE_COMPONENTS_CRUD;

            const successMessage = selectedMode === 0
                ? (editSalaryStructureID !== 0
                    ? 'Salary structure updated Successfully'
                    : 'New Salary structure Created Successfully')
                : 'Issued indent Approved Successfully';

            // Await the API response
            const data = await RequestIndentCRUD(apiEndpoint, requestBody);

            if (data?.length > 0) {
                callMessage('info', successMessage, 'info');
            } else {
                callMessage('error', 'No data received from API', 'Error');
            }
        } catch (error) {
            callMessage('error', error.message || 'An unexpected error occurred', 'Error');
        }
    }, [callMessage]);

    return { processIndent };

}
export default useSalaryStructureCRUD;